import { Route, Routes } from 'react-router-dom';
import VehicleChecksList from './vehicle-checks-list';
import VehicleChecksItem from './vehicle-checks-item';

const VehicleChecksRouting = () => {
  return (
    <Routes>
      <Route path='' element={<VehicleChecksList />} />
      <Route path=':uid' element={<VehicleChecksItem />} />
    </Routes>
  );
};

export default VehicleChecksRouting;
